import styled from './Step.module.scss'
import InputComponents from './InputComponent/InputComponent'
import useStep from './hooks/useStep'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../module/rootStore'
import StepInputInfo from './StepInputInfo/StepInputInfo'
import useScroll from './hooks/useScroll'
import Tooltip from '../Tooltip/Tooltip'

const Step = () => {
  const { wrapperRef, inputsRefs } = useStep()
  const { stepsInputs, currentStep } = useStore().StepsStore
  useScroll({ currentStep })

  return (
    <div className={styled.container}>
      <div className={styled.wrapper} ref={wrapperRef}>
        {stepsInputs &&
          stepsInputs[currentStep].map((name, index) => {
            return (
              <StepInputInfo
                name={name}
                currentStep={currentStep}
                inputRef={(el: HTMLDivElement) =>
                  (inputsRefs.current[index] = el)
                }
                key={name}
              >
                <InputComponents name={name} />
              </StepInputInfo>
            )
          })}
      </div>
      <Tooltip />
    </div>
  )
}

export default observer(Step)
